import { render, staticRenderFns } from "./GscSnapshotPage.vue?vue&type=template&id=46a20066&scoped=true"
import script from "./GscSnapshotPage.vue?vue&type=script&lang=ts"
export * from "./GscSnapshotPage.vue?vue&type=script&lang=ts"
import style0 from "./GscSnapshotPage.vue?vue&type=style&index=0&id=46a20066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a20066",
  null
  
)

export default component.exports